import { render, staticRenderFns } from "./MyPageHistoryDetail.vue?vue&type=template&id=0f6816d7&"
import script from "./MyPageHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./MyPageHistoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports